module.exports = __webpack_public_path__ + "static/media/icons_Bilan Bronchiolite (reco 2019, nourrisson -12 mois).debb32b3.svg";